import { render } from "./QualificationDropdown.vue?vue&type=template&id=9cbf3140"
import script from "./QualificationDropdown.vue?vue&type=script&lang=js"
export * from "./QualificationDropdown.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__